var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70.033 70.2457C72.09 70.2457 74.0628 71.0629 75.5173 72.5174C76.9719 73.9719 77.789 75.9447 77.789 78.0017L77.7839 81.872C78.3164 91.3679 71.0025 96.1042 57.4373 96.1042C43.9185 96.1042 36.4443 91.43 36.4443 82.0064V78.0017C36.4443 75.9447 37.2615 73.9719 38.716 72.5174C40.1706 71.0629 42.1433 70.2457 44.2003 70.2457H70.033ZM90.7157 70.2457C92.7727 70.2457 94.7455 71.0629 96.2 72.5174C97.6546 73.9719 98.4717 75.9447 98.4717 78.0017V80.7241C98.9371 89.2428 92.4737 93.5137 80.6613 93.5137C79.0584 93.5137 77.5512 93.4362 76.1422 93.2811C78.9188 90.7164 80.4028 87.2391 80.3976 82.8441L80.364 81.7272L80.3744 78.0017C80.3758 76.5341 80.064 75.0831 79.4599 73.7456C78.8558 72.4081 77.9733 71.2149 76.8712 70.2457H90.7183H90.7157ZM57.127 39.2217C60.5561 39.2217 63.8447 40.5839 66.2694 43.0086C68.6941 45.4333 70.0563 48.7219 70.0563 52.1509C70.0563 55.58 68.6941 58.8686 66.2694 61.2933C63.8447 63.718 60.5561 65.0802 57.127 65.0802C53.698 65.0802 50.4094 63.718 47.9847 61.2933C45.5599 58.8686 44.1978 55.58 44.1978 52.1509C44.1978 48.7219 45.5599 45.4333 47.9847 43.0086C50.4094 40.5839 53.698 39.2217 57.127 39.2217ZM82.9804 44.3924C85.7231 44.3924 88.3534 45.4819 90.2928 47.4213C92.2322 49.3606 93.3217 51.991 93.3217 54.7337C93.3217 57.4764 92.2322 60.1068 90.2928 62.0461C88.3534 63.9855 85.7231 65.075 82.9804 65.075C80.2377 65.075 77.6073 63.9855 75.668 62.0461C73.7286 60.1068 72.639 57.4764 72.639 54.7337C72.639 51.991 73.7286 49.3606 75.668 47.4213C77.6073 45.4819 80.2377 44.3924 82.9804 44.3924Z",
    fill: "#FD9801"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 67.5556,
    cy: 67.6669,
    r: 65.3333,
    stroke: "#FD9801",
    strokeWidth: 4.44444
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customer-icon.55cec42ead1a508ac19236aa220701ca.svg";
export { ForwardRef as ReactComponent };